import React from 'react'

import BaseButton from '../base/base_button'

const CancelButton = props => (
	<BaseButton
		{...props}
		bgColor='border-gray'
	/>
)

export default CancelButton
